import { combineReducers } from '@reduxjs/toolkit';

import { bodyType } from './bodyType';
import { characteristic } from './characteristic';
import { techData } from './techData';
import { mark } from './mark';
import { model } from './model';
import { modification } from './modification';
import { generation } from './generation';
import { type } from './type';

export default combineReducers({
    type,
    mark,
    model,
    generation,
    bodyType,
    modification,
    techData,
    characteristic,
});
